module.exports = __webpack_public_path__ + "img/founders_2.1e6485b0.jpg";